import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader, Grid, Typography } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const RegisteredPersonsChart: React.FC = () => {
  const {
    chartsInfo: { registeredPersons },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader title="IFEPAF + IFBOLSAS" subheader="PESSOAS CADASTRADAS" />

      <Grid container>
        <Grid item xs={6}>
          <Chart
            chartType="PieChart"
            data={registeredPersons?.previous.data}
            options={{
              ...defaultChartOptions,
              title: registeredPersons?.previous.title,
              legend: 'none',
              pieSliceText: 'label',
              colors: ['#616161', '#7D7D7D', '#949494', '#A5A5A5', '#BABABA'],
            }}
          />

          <Grid container justifyContent="center" style={{ paddingBottom: 10 }}>
            <Typography variant="caption">
              <strong>Total: {registeredPersons?.previous.total}</strong>
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Chart
            chartType="PieChart"
            data={registeredPersons?.current.data}
            options={{
              ...defaultChartOptions,
              title: registeredPersons?.current.title,
              legend: 'none',
              pieSliceText: 'label',
            }}
          />

          <Grid container justifyContent="center" style={{ paddingBottom: 10 }}>
            <Typography variant="caption">
              <strong>Total: {registeredPersons?.current.total}</strong>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Chart
            chartType="PieChart"
            data={registeredPersons?.previous.data}
            options={{
              ...defaultChartOptions,
              title: registeredPersons?.previous.title,
              legend: 'none',
              pieSliceText: 'label',
              colors: ['#616161', '#7D7D7D', '#949494', '#A5A5A5', '#BABABA'],
            }}
          />

          <div style={{ backgroundColor: 'blue', width: '80%' }}>
            <Typography variant="caption" align="center">
              Total: {registeredPersons?.previous.total}
            </Typography>
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <Chart
            chartType="PieChart"
            data={registeredPersons?.current.data}
            options={{
              ...defaultChartOptions,
              title: registeredPersons?.current.title,
              legend: 'none',
              pieSliceText: 'label',
            }}
          />
        </div>
      </div> */}
    </Card>
  );
};

export default RegisteredPersonsChart;
